"use client";

import Link from "next/link";
import { JSX } from "react";

interface ServiceCardProps {
  slug: string;
  title: string;
  icon: JSX.Element;
  locale: "pt" | "en";
}

export default function ServiceCard({ slug, title, icon, locale }: ServiceCardProps) {
  return (
    <Link
      href={`/${locale}/services/${slug}`}
      className="flex items-center bg-white p-2 md:p-4 rounded-xl shadow border border-[#CBD5E1] hover:shadow-md transition cursor-pointer"
    >
      <div className="flex items-center gap-2 lg:gap-3">
        <div className="w-10 h-10 lg:w-12 lg:h-12 bg-[#1B475D] rounded-full flex items-center justify-center text-2xl">
          {icon}
        </div>
        <p className="text-[12px] sm:text-sm lg:text-lg text-[#1B475D] font-semibold">
          {title}
        </p>
      </div>
    </Link>
  );
}
